/* eslint-disable local-rules/ordered-imports */
// @ts-strict-ignore
import './utils/honeycomb-observability';
import './utils/error-reporting';
import './utils/onload-init';
import '../csrf';
import 'common/widgets/browser-context-root';
import 'iron/gdpr';

import * as React from 'react';
import ReactDOM from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import {getAppRouter} from '#iron/routes/router';
import {ToastAreaRoot} from 'common/components/toast-area';
import {initializeCustomerIO} from 'common/util/customerio-sdk';
import {NuqsAdapter} from 'nuqs/adapters/react-router/v6';

import 'common/stylesheets/defaults/global.styl';

// Initialize Customer.io SDK immediately to avoid race conditions
// This must execute before other modules that call identifyCustomerIOUser()
initializeCustomerIO();

document.addEventListener(`DOMContentLoaded`, () => {
  const appContainer = document.getElementById(`mixpanel-app-wrapper`);
  const root = ReactDOM.createRoot(appContainer);
  root.render(
    <React.StrictMode>
      <NuqsAdapter>
        <ToastAreaRoot />
        <RouterProvider router={getAppRouter()} />
      </NuqsAdapter>
    </React.StrictMode>,
  );
});
